import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  HomeOutlined,
  HomeFilled,
  CompassOutlined,
  CalendarOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useSupportChat } from '../../context/SupportChatContext';
import AiSparkleIcon from './AiSparkleIcon';
import './DesktopSideNav.css';

const NAV_ITEMS = [
  { key: '/home', label: 'Home', icon: HomeOutlined, iconActive: HomeFilled },
  { key: '/explore', label: 'Explore', icon: CompassOutlined, iconActive: CompassOutlined },
  { key: '/booking-history', label: 'Bookings', icon: CalendarOutlined, iconActive: CalendarOutlined },
  { key: '/settings', label: 'Profile', icon: UserOutlined, iconActive: UserOutlined },
] as const;

const DesktopSideNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { open: aiOpen, toggleChat } = useSupportChat();

  return (
    <aside className="desktop-side-nav" aria-label="Main navigation">
      <button type="button" className="desktop-side-nav__brand" onClick={() => navigate('/home')}>
        <span className="desktop-side-nav__logo">SOC</span>
        <span className="desktop-side-nav__tagline">Service on Click</span>
      </button>

      <nav className="desktop-side-nav__links">
        {NAV_ITEMS.map(({ key, label, icon: Icon, iconActive: IconActive }) => {
          const isActive = location.pathname === key;
          const NavIcon = isActive ? IconActive : Icon;
          return (
            <button
              key={key}
              type="button"
              className={`desktop-side-nav__link${isActive ? ' desktop-side-nav__link--active' : ''}`}
              onClick={() => navigate(key)}
              aria-current={isActive ? 'page' : undefined}
            >
              <NavIcon aria-hidden />
              <span>{label}</span>
            </button>
          );
        })}
      </nav>

      <button
        type="button"
        className={`desktop-side-nav__ai${aiOpen ? ' desktop-side-nav__ai--open' : ''}`}
        onClick={toggleChat}
        aria-label={aiOpen ? 'Close SOC AI' : 'Open SOC AI assistant'}
        aria-expanded={aiOpen}
      >
        <span className="desktop-side-nav__ai-icon">
          <AiSparkleIcon size={22} />
        </span>
        <span>SOC AI Assistant</span>
      </button>
    </aside>
  );
};

export default DesktopSideNav;
